import { createContext } from "react";

import { ParamsModel } from "./ParamsModel";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ParamsContextProps extends ParamsModel {}

export const ParamsContext = createContext({} as ParamsContextProps);
